import i18n from "i18next";

// ---------- Rate calculation helpers ----------
export const getRate = (v) => (v > 1 ? v / 100 : v); // normalize to 0..1

export const bucket = (rate) =>
  rate < 0.1 ? "low" : rate < 0.2 ? "med" : "high";

export const colorFor = (rate) => {
  const b = bucket(rate);
  if (b === "low") return "#e05578"; // 🌿 green
  if (b === "med") return "#d32f2f"; // 😐 amber
  return "#595959"; // 🔥 red
};

export const labelFor = (rate) =>
  `${Math.round(rate * 100)}% • ${bucket(rate).toUpperCase()}`;

// Get cause translations occurrences for filtered moods only
export function getCauseTranslationOccurrences(
  filteredMoods,
  causes,
  allCauseTypes,
  causeTypesTranslations
) {
  const arr = [];
  const safeMoods = Array.isArray(filteredMoods) ? filteredMoods : [];
  const safeCauses = Array.isArray(causes) ? causes : [];
  const safeAllCauseTypes = Array.isArray(allCauseTypes) ? allCauseTypes : [];
  const safeCauseTypesTranslations = Array.isArray(causeTypesTranslations)
    ? causeTypesTranslations
    : [];
  const causeTypeById = new Map(
    safeAllCauseTypes
      .filter((ct) => ct && typeof ct.id === "string")
      .map((ct) => [ct.id, ct])
  );
  const translationDocById = new Map(
    safeCauseTypesTranslations
      .filter((t) => t && typeof t.id === "string")
      .map((t) => [t.id, t])
  );

  console.log("000 m " + JSON.stringify(safeMoods))
  console.log("000 c " + JSON.stringify(safeCauses))
  safeMoods.forEach((mood) => {
    const moodCauses = safeCauses.filter((c) => c.moodId === mood.id);
    moodCauses.forEach((cause) => {
      if (cause.causeTypeId != null) {
        const found = causeTypeById.get(cause.causeTypeId);
        let translationText = null;

        if (found) {
          const translationDoc = translationDocById.get(
            found.causeTranslationId
          );
          if (translationDoc) {
            translationText = translationDoc[i18n.language];
          }

          if (!translationText && found.causeTypeTranslation) {
            translationText =
              found.causeTypeTranslation[i18n.language] ||
              found.causeTypeTranslation.en ||
              found.causeTypeTranslation.ru ||
              found.causeTypeTranslation.et;
          }

          if (!translationText) {
            translationText =
              found.translation || found.mood || found.name || null;
          }
        }

        // Fallback when cause types are missing/not loaded:
        // still count by translation doc id or raw causeTypeId.
        if (!translationText) {
          const directTranslationDoc = translationDocById.get(
            cause.causeTypeId
          );
          if (directTranslationDoc) {
            translationText =
              directTranslationDoc[i18n.language] ||
              directTranslationDoc.en ||
              directTranslationDoc.ru ||
              directTranslationDoc.et ||
              null;
          }
        }

        if (!translationText && typeof cause.causeTypeId === "string") {
          translationText = cause.causeTypeId;
        }

        if (translationText) {
          arr.push(translationText);
        }
      }
    });
  });

  const counts = arr.reduce((acc, curr) => {
    acc[curr] = (acc[curr] || 0) + 1;
    return acc;
  }, {});

  console.log("000 counts is " + JSON.stringify(counts))
  return counts;
}
